<template>
	<nav>
		<ul class="link-list" :class="isMobile ? 'mobile' : ''">
			<div v-for="(route, index) in navItems" :key="route.label">
				<transition-group :key="`transition-${route.path}`" name="fade">
					<router-link
						:to="route.path"
						:class="getActiveParent(route)"
						:key="index"
						@click.native="closeSidebar(index)"
					>
						<div class="box-icon">
							<component :is="route.icon" class="link-list__icon" :color="getIconColor(route)" />
						</div>
						<p class="hide">
							{{ route.label }}
						</p>
					</router-link>
					<template v-if="hasChild(route)">
						<router-link
							v-for="(chield, index) in route.children"
							:key="`chield-${index}`"
							:to="chield.path"
							:class="getActiveChild(chield)"
							@click.native="handleActiveSubmenu(index)"
						>
							<div class="box-icon">
								<component :is="chield.icon" class="link-list__icon" color="#597393" />
							</div>
							<p class="hide">
								{{ chield.label }}
							</p>
						</router-link>
					</template>
				</transition-group>
			</div>
			<div class="link-list__item" @click="logout()" v-if="isMobile">
				<div class="box-icon">
					<ExitIcon class="link-list__icon" />
				</div>
				<p class="hide">Sair</p>
			</div>
		</ul>
	</nav>
</template>

<script>
import UserIcon from '@/components/shared/Icons/UserIcon.vue';
import InvestorIcon from '@/components/shared/Icons/InvestorIcon.vue';
import OriginatorIcon from '@/components/shared/Icons/OriginatorIcon.vue';
import OffersIcon from '@/components/shared/Icons/OffersIcon.vue';
import SettingsIcon from '@/components/shared/Icons/SettingsIcon.vue';
import ExitIcon from '@/components/shared/Icons/ExitIcon.vue';
import OperationTypeIcon from '@/components/shared/Icons/OperationTypeIcon.vue';
import IndustryIcon from '@/components/shared/Icons/IndustryIcon.vue';
import OfferStatusIcon from '@/components/shared/Icons/OfferStatusIcon.vue';
import DocSubtypeIcon from '@/components/shared/Icons/DocSubtypeIcon.vue';
import MoneyIcon from '@/components/shared/Icons/MoneyIcon.vue';
import AnalyticsIcon from '@/components/shared/Icons/AnalyticsIcon.vue';
import LockIcon from '../Icons/LockIcon.vue';
import clearApp from '@/utils/clearApp';

export default {
	name: 'MenuContent',
	components: {
		UserIcon,
		InvestorIcon,
		OriginatorIcon,
		OffersIcon,
		SettingsIcon,
		ExitIcon,
		OperationTypeIcon,
		IndustryIcon,
		OfferStatusIcon,
		DocSubtypeIcon,
		MoneyIcon,
		LockIcon,
		AnalyticsIcon,
	},
	props: {
		isMobile: {
			default: false,
		},
	},
	data: () => ({
		title: '',
		uploadContracts: false,
		isUploadActive: false,
		lastSelectedItem: 0,
		lastChieldSelectedItem: 0,
		navItems: [
			{
				label: 'Analytics',
				path: '/dashboard/analytics',
				icon: 'AnalyticsIcon',
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Usuários',
				path: '/dashboard/users',
				icon: 'UserIcon',
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Investidores',
				path: '/dashboard/investors',
				icon: InvestorIcon,
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Estruturadores',
				path: '/dashboard/structurer',
				icon: MoneyIcon,
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Originadores',
				path: '/dashboard/originators',
				icon: OriginatorIcon,
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Ofertas',
				path: '/dashboard/offers',
				icon: OffersIcon,
				isActive: false,
				showOnMenu: true,
			},
			{
				label: 'Configurações',
				path: '/dashboard/config',
				icon: SettingsIcon,
				isActive: false,
				showOnMenu: true,
				children: [
					{
						label: 'Indústrias',
						path: '/dashboard/config/industryType',
						icon: IndustryIcon,
						isActive: true,
						isChield: true,
					},
					{
						label: 'Status da Oferta',
						path: '/dashboard/config/offerStatus',
						icon: OfferStatusIcon,
						isActive: false,
						isChield: true,
					},
					{
						label: 'Tipo de Operação',
						path: '/dashboard/config/operationType',
						icon: OperationTypeIcon,
						isActive: false,
						isChield: true,
					},
					{
						label: 'Tipo de Documento',
						path: '/dashboard/config/docType',
						icon: DocSubtypeIcon,
						isActive: false,
						isChield: true,
					},
					{
						label: 'Subtipo de Documentos',
						path: '/dashboard/config/docSubtype',
						icon: DocSubtypeIcon,
						isActive: false,
						isChield: true,
					},
				],
			},
			{
				label: 'Administradores',
				path: '/dashboard/admins',
				icon: LockIcon,
				isActive: false,
				showOnMenu: true,
			},
		],
	}),
	created() {},
	methods: {
		closeSidebar(selectedIndex) {
			this.clearChieldItems();
			this.handleActiveMenu(selectedIndex);
			if (this.isMobile) this.$emit('handleSidebar');
		},
		handleActiveMenu(selectedIndex) {
			this.navItems[this.lastSelectedItem].isActive = false;
			this.navItems[selectedIndex].isActive = true;
			this.lastSelectedItem = selectedIndex;
		},
		clearChieldItems() {
			this.lastChieldSelectedItem = 0;
			this.navItems[this.getConfigurationMenuIndex].children = this.navItems[
				this.getConfigurationMenuIndex
			].children.map((optionSubmenu, index) => {
				if (index === 0) {
					optionSubmenu.isActive = true;
				} else {
					optionSubmenu.isActive = false;
				}
				return optionSubmenu;
			});
		},
		logout() {
			clearApp();
			this.$router.push('/login');
		},
		getTemplate() {
			const template = `
			<div class="custom-tooltip bottom-arrow">
				<span class="custom-tooltip__text">
					Em breve
				</span>
			</div>`;

			return template;
		},
		getActiveParent(route) {
			return {
				'router-link-exact-active router-link-active': route.isActive,
				'link-list__item': true,
			};
		},
		getActiveChild(route) {
			return {
				'router-link-exact-active--chield': route.isActive,
				'link-list__item': true,
				'link-list__item--chield': true,
			};
		},
		getIconColor(route) {
			return route.isActive ? 'white' : '#597393';
		},
		handleActiveSubmenu(selectedIndex) {
			const configMenuOptions = this.navItems[this.getConfigurationMenuIndex].children;
			configMenuOptions[this.lastChieldSelectedItem].isActive = false;
			configMenuOptions[selectedIndex].isActive = true;
			this.lastChieldSelectedItem = selectedIndex;
		},
		hasChild(route) {
			return route.children && this.navItems[this.getConfigurationMenuIndex].isActive;
		},
	},
	computed: {
		getConfigurationMenuIndex() {
			return this.navItems.findIndex((option) => option.children);
		},
	},
	watch: {
		$route: {
			handler(route) {
				this.title = route.name;
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss">
@import 'MenuContent.scss';
</style>
